import { render, staticRenderFns } from "./SettingOption.vue?vue&type=template&id=6dc1730d&scoped=true"
import script from "./SettingOption.vue?vue&type=script&lang=js"
export * from "./SettingOption.vue?vue&type=script&lang=js"
import style0 from "./SettingOption.vue?vue&type=style&index=0&id=6dc1730d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1730d",
  null
  
)

export default component.exports